/**
 * NPI format check only (no registry lookup).
 * Valid when exactly 10 digits (after stripping spaces/hyphens) and the
 * Luhn check digit on prefix "80840" + those digits passes.
 */

function stripNpiSeparators(value) {
  return String(value ?? "").replace(/[\s-]/g, "");
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidNpiFormat(value) {
  if (value == null) return false;
  const digits = stripNpiSeparators(value);
  if (!/^\d{10}$/.test(digits)) return false;

  const payload = `80840${digits}`;
  let sum = 0;
  // Luhn: from the right, double every second digit (rightmost is position 1).
  for (let i = 0; i < payload.length; i += 1) {
    let digit = Number(payload[payload.length - 1 - i]);
    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }
  return sum % 10 === 0;
}

export function normalizeNpiDigits(value) {
  return stripNpiSeparators(value);
}
